
import { useSearchParams } from "react-router-dom";
import useWindowDimensions from "./useWindowDimensions";
import { useSelector } from "react-redux";
import LocalStorageService from "../common/services/LocalStorageService";
import Utils from "../utils";

const doSearch = (value, cb, cancelDebounce) => {
  if (!cancelDebounce) {
    cb({
      page: 1,
      per_page: 10,
      name: value ? value : undefined,
    });
  }
};
const debouncedSearch = Utils?.debounce(doSearch, 500);

export default function useStep1(searchVal,setSearchVal) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { width, isMobile, isSmallMobile } = useWindowDimensions();
  const { isAuthenticated } = useSelector((state) => state?.auth);
  const is_search_count_gt_5 = LocalStorageService?.get("search_count") >= 5 && !isAuthenticated

  const setUrlSearchParams = (newParams) => {
    const filteredSearchParams = Utils?.get_filtered_url_params(searchParams, {
      name: searchParams?.get("name") ? searchParams?.get("name") : undefined,
      step: searchParams?.get("step") ? searchParams?.get("step") : undefined,
      page: searchParams?.get("page") ? searchParams?.get("page") : 1,
      per_page: searchParams?.get("per_page")
        ? searchParams?.get("per_page")
        : 10,
      role: searchParams?.get("role") ? searchParams?.get("role") : undefined,
      ...newParams,
    });
    setSearchParams(filteredSearchParams);
    if (!isAuthenticated) {
      let search_count = LocalStorageService?.get("search_count");
      LocalStorageService?.set("search_count", search_count + 1);
    }
  };

  const onSearch = (value, cancelDebounce) => {
    if (!cancelDebounce) {
      setSearchVal(value);
    }
    debouncedSearch(
      value,
      () => {
        setUrlSearchParams({
          page: 1,
          per_page: 10,
          name: value ? value : undefined,
        });
      },
      cancelDebounce
    );
  };

  return {
    onSearch,
    setUrlSearchParams,
    is_search_count_gt_5,
    width,
    isMobile,
    isSmallMobile,
  };
}
